import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Linkedin, Instagram, Mail } from 'lucide-react';
import { Shield, Lock, Award } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      { label: 'Medical Coding', href: '#services' },
      { label: 'Claims Management', href: '#services' },
      { label: 'Denial Management', href: '#services' },
      { label: 'A/R Recovery', href: '#services' },
    ],
    Company: [
      { label: 'Why Choose Us', href: '#why-us' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'FAQ', href: '#faq' },
    ],
    Specialties: [
      { label: 'Family Practice', href: '#specialties' },
      { label: 'Cardiology', href: '#specialties' },
      { label: 'Mental Health', href: '#specialties' },
      { label: 'Physical Therapy', href: '#specialties' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ];

  const complianceBadges = [
    { icon: Shield, label: 'HIPAA' },
    { icon: Lock, label: 'SOC 2' },
    { icon: Award, label: 'AAPC' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 to-[#0f1629] text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <motion.h3
              whileHover={{ scale: 1.02 }}
              className="text-3xl font-bold bg-gradient-to-r from-white to-[#14b8a6] bg-clip-text text-transparent mb-4"
            >
              Bill Well Benefits
            </motion.h3>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Trusted medical billing and revenue cycle management partner for
              healthcare providers nationwide. Maximize revenue, minimize denials.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={index}
                    href={social.href}
                    whileHover={{ scale: 1.2, y: -2 }}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#14b8a6] flex items-center justify-center transition-all duration-300"
                    aria-label={social.label}
                  >
                    <Icon size={18} />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-bold text-lg mb-4">{category}</h4>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-slate-400 hover:text-[#14b8a6] transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Compliance badges */}
        <div className="border-t border-slate-700 pt-8 mb-8">
          <div className="flex flex-wrap justify-center gap-8">
            {complianceBadges.map((badge, index) => {
              const Icon = badge.icon;
              return (
                <motion.div
                  key={index}
                  whileHover={{ y: -5 }}
                  className="flex items-center gap-2 text-slate-400"
                >
                  <Icon size={20} className="text-[#14b8a6]" />
                  <span className="font-medium">{badge.label} Compliant</span>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-slate-400 text-sm">
          <p>© {currentYear} Bill Well Benefits. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#14b8a6] transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#14b8a6] transition-colors">
              Terms of Service
            </a>
            <a href="#contact" onClick={(e) => scrollToSection(e, '#contact')} className="hover:text-[#14b8a6] transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
